import { useEffect, useState } from "react";
import { GetAllFolloUpUser } from "../../services/followUpService";

const ViewFollowUpUser=({userId})=>{
    console.log(userId);
const [userData, setUserData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    useEffect(() => {
        setLoading(true);
        const fetchData = async () => {
            try {
                const response = await GetAllFolloUpUser(userId);
                const data = response.data;
                console.log(data);
                if (response.statusCode === 200 && response.success === true) {
                    setError("");
                    setUserData(data);
                }
                else {
                    setError("something went wrong");
                }
            } catch (error) {

                console.log(error);
                setError(error.message || "Something went wrong");
            } finally {
                setLoading(false);
            }
        }

        fetchData();
    }, [userId]);
    return (
        <div className="container mt-4">
            <div className="card shadow">
                <div className="card-header bg-primary text-white">
                    <h4 className="mb-0">List User </h4>
                </div>
                <div>
                    
                </div>
                <div className="card-body">
                    {loading ? (
                        <p>Loading...</p>
                    ) : error ? (
                        <div className="alert alert-danger">{error}</div>
                    ) : (
                        <>
                            {/* Total Records */}
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5 className="mb-0">
                                    Total Records:
                                    <span className="badge bg-primary ms-2">
                                        {userData.length}
                                    </span>
                                </h5>
                               
                               
                            </div>
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover align-middle">
                                    <thead className="table-dark">
                                        <tr>
                                            <th>#</th>
                                            <th>User Name</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {userData.length > 0 ? (
                                            userData.map((user, index) => (
                                                <tr key={user.id}>
                                                    <td>{index + 1}</td>
                                                    <td>{user.userName}</td>
                                                    <td>{user.isActive ? "Active" : "Inactive"}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td
                                                    colSpan="4"
                                                    className="text-center"
                                                >
                                                    No Data Found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
export default ViewFollowUpUser;